module.exports = __webpack_public_path__ + "static/media/controlled-breathing-large.cb817ab5.png";